import { DEFAULT_API_HOST } from '@/config/env'
import { buildOpenApiUrl } from '@/utils/apiUrl'
import {
  hmacSha256Hex,
  buildSignaturePayload,
  unixTimestampSeconds
} from '@/utils/goovalAuth'
import http from '@/utils/http'

/** 凭证探活：任一 2xx 即视为 Store Number + Secret 可用 */
export const CREDENTIAL_PROBE_COLLECTIONS = [
  'product-categories',
  'countries',
  'cancel-reasons'
]

function responseErrorHint (res) {
  const data = res?.data
  if (data && typeof data === 'object') {
    const code = data.error || data.code
    const msg = data.message
    if (code && msg) return `${code}: ${msg}`
    if (code) return String(code)
    if (msg) return String(msg)
  }
  return `HTTP ${res?.status ?? 'error'}`
}

export async function verifyOpenApiCredentials (
  { storeNumber, apiSecret },
  apiHost = DEFAULT_API_HOST
) {
  const sn = String(storeNumber || '').trim()
  const secret = String(apiSecret || '').trim()
  const rawBody = ''
  const timestamp = unixTimestampSeconds()
  const signature = await hmacSha256Hex(
    secret,
    buildSignaturePayload(sn, timestamp, rawBody)
  )
  const headers = {
    'X-Gwofy-Store-Number': sn,
    'X-Gwofy-Timestamp': timestamp,
    'X-Gwofy-Signature': signature
  }

  const paths = CREDENTIAL_PROBE_COLLECTIONS.map(
    (c) => `/reference-data/${c}`
  )

  let networkError = null
  const results = await Promise.all(
    paths.map(async (path) => {
      const url = buildOpenApiUrl(path, '', apiHost)
      try {
        const res = await http.get(url, { headers, responseType: 'json' })
        return { path, res, ok: res.status >= 200 && res.status < 300 }
      } catch (e) {
        networkError = e
        return { path, res: null, ok: false, error: e }
      }
    })
  )

  const success = results.find((r) => r.ok)
  if (success) {
    return {
      valid: true,
      path: success.path,
      status: success.res.status
    }
  }

  if (networkError && results.every((r) => !r.res)) {
    return {
      valid: false,
      message: networkError.message || '网络请求失败（可检查 CORS 或 API 是否可达）'
    }
  }

  const hints = results
    .filter((r) => r.res)
    .map((r) => `${r.path} → ${responseErrorHint(r.res)}`)
  return {
    valid: false,
    message: hints.length
      ? `凭证校验未通过：${hints.join('；')}`
      : '凭证校验未通过'
  }
}
